// Whether `value` is an inline `data:image/…` URL. Peers only ever send
// images this way (avatars, chat attachments, whiteboard images), so
// receivers accept nothing else: any other URL would make every
// participant's browser fetch it — a remote tracking pixel that leaks each
// viewer's IP, or a `file://` load Firefox blocks with a security error.
// Anchored, so it inspects only the header however large the payload is.
export function isImageDataUrl(value: unknown): value is string {
  return typeof value === 'string' && /^data:image\/[a-z0-9.+-]+[;,]/i.test(value);
}
